export default "__VITE_ASSET__Caz5EtP5__"